class ServiceBase {
  init(http, vue, store, router) {
    this.http = http;
    this.vue = vue;
    this.store = store;
    this.router = router;
  }
}

export default ServiceBase;
